import { useEffect, useState } from "react";
import envConfig from "src/envConfig/envHelper";
import browserAgent from "src/BrowserAgent";

export const KasadaIntegration = () => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const kasadaConfig = envConfig?.config?.kasada;

  useEffect(() => {
    if (loaded || !kasadaConfig?.enabled) {
      return;
    }
    setLoaded(true);

    const configureKasada = () => {
      (window as any)?.KPSDK?.configure([
        {
          domain: window.location.host,
          method: "*",
          path: "/api/connect/address/lookup",
          protocol: "https",
        },
        {
          domain: window.location.host,
          method: "*",
          path: "/api/connect/*",
          protocol: "https",
        },
      ]);
    };

    document.addEventListener("kpsdk-load", configureKasada);

    const script = document.createElement("script");
    script.setAttribute("src", kasadaConfig.scriptPath);
    script.onerror = () => {
      browserAgent?.noticeError?.(
        new Error(`Kasada script failed to load: ${kasadaConfig.scriptPath}`)
      );
      // eslint-disable-next-line no-console
      console.error("Kasada script failed to load", kasadaConfig.scriptPath);
    };
    document.head.appendChild(script);
  }, [loaded, kasadaConfig]);

  return null;
};
